module.exports = __webpack_public_path__ + "img/武器装备.f11ba3e3.png";